import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { FullEventDisplay } from '../components/better/fullEventDisplay';
import { MoreWaysFooter } from '../components/moreWaysFooter';
import { featureIsEnabled, useFeatures } from '../hooks/features';
import { NAVIGATION_REDESIGN } from '../utils/constants';

export function ViewEvent() {
  const [searchParams] = useSearchParams();
  const features = useFeatures();
  const isNewNav = featureIsEnabled(NAVIGATION_REDESIGN, features, searchParams);

  return (
    <>
      <FullEventDisplay />
      {!isNewNav && <MoreWaysFooter dark />}
    </>
  );
}
